import logo from './logo.svg';
import poweredBy from './powered-by.svg'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>

  <footer>
    <div class="powered-by">
      <img src={poweredBy} alt="Powered By Logo" className='powered-by'/>
    </div>
  </footer> 
    </div>
  );
}

export default App;
